<template>
  <div class="bulk-creation-form">
    <PageHeader showBreadcrumbs :customBreadcrumbs='breadcrumbs' :page-title="title" wrapperClassName="d-flex" titleClassName="flex-grow-1">
      <template #buttons>
        <div class="d-flex align-items-center">
          <CloseButton tooltip="Close form" :onClick="onCloseButtonClick" />
        </div>
      </template>
    </PageHeader>

    <InvoiceFormCard>
      <template v-if="isLoading && !useSlideoutLoading">
        <div style="min-height: 300px;">
          <Preloader customClasses="form-preloader" />
        </div>
      </template>
      <slot v-else></slot>
    </InvoiceFormCard>
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader.vue'
import CloseButton from '@components/common/CloseButton.vue'
import Preloader from '@components/Preloader.vue'
import InvoiceFormCard from '@components/invoices/form/InvoiceFormCard.vue'

export default {
  name: 'BulkCreationFormContainer',
  components: { PageHeader, CloseButton, Preloader, InvoiceFormCard },
  props: {
    title: {
      type: String,
      required: true
    },
    onCloseButtonClick: {
      type: Function,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    useSlideoutLoading: {
      type: Boolean,
      default: false
    },
    breadcrumbs: { type: Array, default: () => [] }
  }
}
</script>

<style scoped lang="scss">
.bulk-creation-form {
  font-size: $font-size-base-new;
  line-height: 1.154em;
  margin-top: -3px;
}

.form-preloader {
  background-color: rgba($bgColorBase, 0.7);
}
</style>
